import type {ComputeConfig} from 'svelte-floating-ui';
import type {Placement} from '@floating-ui/core';
import {flip, offset, shift} from 'svelte-floating-ui/dom';

export function floatingUiCommonSettings(placement: Placement, offsetInPx: number = 10): ComputeConfig {
    return {
        placement,
        strategy: 'fixed',
        autoUpdate: {
            elementResize: true,
            ancestorResize: true,
            layoutShift: true,
            ancestorScroll: false // I hope this is temporary solution until we fix grid performance
        },
        middleware: [
            offset(offsetInPx),
            flip(),
            shift()
        ]
    };
}